<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 list-page-header">
      <h3 class="title mb-5">{{ $t("setting.school_setting") }}</h3>
    </div>
    <validation-form @on-submit="editForm" class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">
              {{ $t("setting.main_school_information") }}
            </h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout ml-1">
            <div class="md-layout-item">
              <div class="md-layout">
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="parameterValidation.school_name"
                    name="name"
                  >
                    <label>{{ $t("setting.school_name") }}</label>
                    <md-input
                      :readonly="true"
                      v-model.trim="schoolInfo.name"
                    ></md-input>
                  </validation-field>
                </div>
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="parameterValidation.address"
                    name="address"
                  >
                    <label>{{ $t("setting.address") }}</label>
                    <md-input v-model.trim="schoolInfo.address"></md-input>
                  </validation-field>
                </div>
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="parameterValidation.fax"
                    name="fax"
                  >
                    <label>{{ $t("setting.fax") }}</label>
                    <md-input v-model.trim="schoolInfo.fax"></md-input>
                  </validation-field>
                </div>
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="parameterValidation.principal"
                    name="Principal"
                  >
                    <label>{{ $t("setting.principal") }}</label>
                    <md-input v-model.trim="schoolInfo.principal"></md-input>
                  </validation-field>
                </div>
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="parameterValidation.phone_number"
                    name="phone number"
                  >
                    <label>{{ $t("setting.phone_number") }}</label>
                    <md-input v-model.trim="schoolInfo.phone"></md-input>
                  </validation-field>
                </div>
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <validation-field
                    :validations="parameterValidation.timezone"
                    name="timezone"
                    type="autocomplete"
                  >
                    <template #default="{ errors }">
                      <isis-autocomplete
                        v-model="timezoneDisplay"
                        :value.sync="schoolInfo.timezone"
                        :options="timeZoneOpts"
                        label="Time zone"
                        :class="{ 'md-invalid': !!errors.length }"
                      >
                        <span class="md-error" style="top: 35px">{{
                          errors[0]
                        }}</span>
                      </isis-autocomplete>
                    </template>
                  </validation-field>
                </div>
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label :for="otpSelect.name">{{
                      $t(otpSelect.label)
                    }}</label>
                    <md-select
                      :name="otpSelect.name"
                      :id="otpSelect.id"
                      v-model="schoolInfo.otp"
                    >
                      <md-option
                        v-for="option in otpSelect.options"
                        :value="option.id"
                        :key="option.id + option.name"
                        >{{ $t(option.name) }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <!-- Score parameter config  -->
      <md-card class="mt-10">
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">{{ $t("setting.score_parameter") }}</h4>
          </div>
        </md-card-header>
        <md-card-content class="ml-10">
          <p class="template-desc">
            {{ $t("setting.weight_for_each") }}
          </p>
          <div class="md-layout md-gutter pt-4">
            <div class="md-layout-item md-size-33 md-small-size-100">
              {{ $t("setting.category_name") }}
            </div>
            <div class="md-layout-item md-size-33 md-small-size-100">
              {{ $t("setting.will_calculate_as") }}
            </div>
          </div>
          <div
            class="md-layout md-gutter"
            v-for="(parameter, index) in parameterInfo"
            :key="parameter + index"
          >
            <div class="md-layout-item md-size-33 md-small-size-100">
              <validation-field
                :validations="parameterValidation.parameter_name"
                :name="`name ${index + 1}`"
              >
                <md-input
                  v-model="parameter.name"
                  :disabled="isDisableAction"
                ></md-input>
              </validation-field>
            </div>
            <div class="md-layout-item md-size-33 md-small-size-100">
              <validation-field
                :validations="parameterValidation.weight"
                :name="`weight ${index + 1}`"
              >
                <md-input
                  v-model="parameter.weight"
                  :disabled="isDisableAction"
                ></md-input>
                <span class="md-suffix">%</span>
              </validation-field>
            </div>
            <div v-if="isAbleToDeleteParameter" class="actions">
              <md-button
                class="ml-2 md-simple md-just-icon md-icon-button md-danger"
                @click.native="() => deleteParameter(index)"
              >
                <md-icon :style="{ fontSize: '30px !important' }"
                  >delete_forever
                </md-icon>
              </md-button>
            </div>
          </div>
          <span
            v-if="!isDisableAction"
            class="
              md-success
              cursor-pointer
              text-[#4caf50]
              font-medium
              text-[17px]
              mb-5
            "
            @click="addParameter"
          >
            {{ $t("setting.add") }}
          </span>
          <div
            class="
              md-layout md-gutter
              pt-4
              text-center text-red-500
              font-bold
              text-sm
            "
            v-if="errorMsg"
          >
            {{ errorMsg }}
          </div>
        </md-card-content>
      </md-card>

      <!--      Video conference setting-->
      <md-card class="mt-10">
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">{{ $t("setting.vc_setting") }}</h4>
          </div>
        </md-card-header>
        <md-card-content class="ml-10">
          <p class="template-desc pb-4">
            {{ $t("setting.set_user_id") }}
          </p>
          <div class="md-layout md-gutter pt-4">
            <div class="md-layout-item md-size-33 md-small-size-100">
              {{ $t("setting.user_id_email") }}
            </div>
            <div class="md-layout-item md-size-33 md-small-size-100">
              {{ $t("setting.token") }}
            </div>
          </div>
          <div
            class="md-layout md-gutter"
            v-for="(info, index) in userVCRInfo"
            :key="info + index"
          >
            <div class="md-layout-item md-size-33 md-small-size-100">
              <validation-field
                :validations="{ required: true }"
                :name="`User ID / Email ${index + 1}`"
              >
                <md-input
                  v-model="info.account"
                  :disabled="isDisableAction"
                ></md-input>
              </validation-field>
            </div>
            <div class="md-layout-item md-size-40 md-small-size-100">
              <validation-field
                :validations="{ required: true }"
                :name="`token ${index + 1}`"
              >
                <md-input
                  v-model="info.token"
                  :disabled="isDisableAction"
                ></md-input>
              </validation-field>
            </div>
            <div v-if="isAbleToDeleteVCRAccount" class="actions">
              <md-button
                class="ml-2 md-simple md-just-icon md-icon-button md-danger"
                @click.native="() => deleteVCRAccount(index)"
              >
                <md-icon :style="{ fontSize: '30px !important' }"
                  >delete_forever
                </md-icon>
              </md-button>
            </div>
          </div>
          <span
            v-if="!isDisableAction"
            class="
              md-success
              cursor-pointer
              text-[#4caf50]
              font-medium
              text-[17px]
              mb-5
            "
            @click="addVCRAccount"
          >
            {{ $t("setting.add") }}
          </span>
          <div
            class="
              md-layout md-gutter
              pt-4
              text-center text-red-500
              font-bold
              text-sm
            "
            v-if="errorMsg"
          >
            {{ errorMsg }}
          </div>
        </md-card-content>
      </md-card>
      <!--      Chat setting // TODO: disable supporter -->
      <!--      <md-card class="mt-10">
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title text-lg">{{ $t("setting.chat_setting") }}</h4>
                </div>
              </md-card-header>
              <md-card-content class="ml-10">
                <div class="md-layout md-gutter pt-4">
                  <div class="md-layout-item md-size-100">
                    <p class="font-medium text-[#3C4858]">
                      {{ $t("setting.supporter_information") }}
                    </p>
                    <p class="font-normal text-[#000000] text-sm">
                      {{ $t("setting.set_supporters") }}
                    </p>
                  </div>
                  <div class="md-layout-item md-size-100 md-layout my-4">
                    <div class="md-layout-item md-size-40 p-0">
                      <div class="md-layout-item md-size-100 p-0">
                        <p class="text-center text-[#000]">
                          {{ $t("setting.supporter_info") }}
                        </p>
                      </div>
                      <div class="md-layout-item md-size-100 p-0 my-4">
                        <CheckboxMultiSelect
                          :placeholder="chatSetting.placeholder"
                          :options="chatSetting.supporterList"
                          trackBy="_id"
                          displayField="name"
                          v-model="chatSetting.selectedSupporter"
                          :style="{ marginTop: '-6px' }"
                          @filtering="fetchSupporter($event.text)"
                          @select="selectItem"
                          @open="fetchSupporter()"
                          @removed="removedItem"
                          @close="closeSelect"
                        >
                        </CheckboxMultiSelect>
                      </div>
                    </div>
                    <div class="md-layout-item md-size-60 md-layout">
                      <div class="md-layout-item md-size-100">
                        <p class="text-[#000]">
                          {{ $t("setting.list_supporter") }}: ({{
                            chatSetting.supporterSelectedList.length
                          }})
                        </p>
                      </div>
                      <div
                        class="md-layout-item md-size-100 md-layout p-0"
                        v-for="(item, index) in chatSetting.supporterSelectedList"
                        :key="index + 'supporter'"
                      >
                        <div class="md-layout-item md-size-90">
                          {{ index + 1 }}, {{ item.full_name }} -
                          {{ item.staff_code }}
                        </div>
                        <div class="md-layout-item md-size-10 p-0">
                          <md-button
                            class="
                              flex
                              items-end
                              md-simple md-just-icon md-icon-button md-danger
                              h-[15px]
                            "
                            @click="removeSelectedItem(item._id)"
                          >
                            <md-icon>delete_forever</md-icon>
                          </md-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </md-card-content>
            </md-card>-->
      <!--      SMS setting-->
      <md-card class="mt-10">
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">{{ $t("setting.sms_setting") }}</h4>
          </div>
        </md-card-header>
        <md-card-content class="ml-10">
          <h1 class="template-desc pb-4">
            {{ $t("setting.token_application") }}
          </h1>
          <p class="template-desc pb-4">
            {{ $t("setting.set_token") }}
          </p>
          <div class="md-layout">
            <div class="md-layout-item md-size-25 md-small-size-100 pl-0">
              <md-field>
                <label>{{ $t("setting.provider") }}</label>
                <md-select name="smsSetting" id="smsId" v-model="providerId">
                  <md-option
                    v-for="option in providerList"
                    :value="option.id"
                    :key="option.id + option.provider"
                    >{{ $t(option.provider) }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25 md-small-size-100">
              <md-field>
                <label>{{ $t("setting.user_id") }}</label>
                <md-input v-model="providerInfo.external_id"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25 md-small-size-100">
              <md-field>
                <label>{{ $t("setting.token_application") }}</label>
                <md-input v-model="providerInfo.token"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25 md-small-size-100">
              <md-field>
                <label>{{ $t("common.phone_number") }}</label>
                <md-input v-model="providerInfo.phone_number"></md-input>
              </md-field>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <!-- form actions -->
      <div class="form-actions pt-3">
        <md-button type="submit" class="md-success"
          >{{ $t("common.update") }}
        </md-button>
      </div>
    </validation-form>
  </div>
</template>
<script>
import { validations } from "@/validations/school_parameter";
import { TIMEZONE_OPTION } from "@/constants/Timezone";
import { service_names, service_paths } from "@/constants/Services";
import { getId, Message } from "@/helpers/utils";
import pick from "lodash/pick";
import { mapActions } from "vuex";

const parameterDefault = () => {
  return [{ name: "", weight: "" }];
};
const userVCRDefault = () => {
  return [{ account: "", token: "" }];
};
export default {
  components: {
    // CheckboxMultiSelect
  },
  data() {
    return {
      schoolInfo: {
        name: "",
        fax: "",
        principal: "",
        phone: "",
        address: "",
        timezone: "",
        otp: ""
      },
      timeZoneOpts: TIMEZONE_OPTION,
      timezoneDisplay: "",
      parameterInfo: parameterDefault(),
      isDisableAction: false,
      parameterValidation: validations,
      errorMsg: "",
      schoolId: null,
      parameterInfoDefault: parameterDefault(),
      otpSelect: {
        label: "setting.otp_authentication",
        name: "type__",
        value: "normal",
        type: "select",
        options: [
          {
            id: "SMS",
            name: "setting.sms"
          },
          {
            id: "EMAIL",
            name: "setting.email"
          },
          {
            id: "NONE",
            name: "setting.none"
          }
        ]
      },
      //  video conference
      userVCRInfo: [],
      /*chatSetting: {
       supporterList: [],
       selectedSupporter: [],
       supporterSelectedList: [],
       placeholder: this.$t("setting.search_by")
       },*/
      // sms setting
      providerInfo: {
        external_id: null,
        token: null,
        phone_number: null
      },
      providerList: {},
      providerId: null
    };
  },
  computed: {
    isAbleToDeleteParameter() {
      return this.parameterInfo.length > 1;
    },
    isAbleToDeleteVCRAccount() {
      return this.userVCRInfo.length > 1;
    }
  },
  created() {
    this.fetchSchoolInfo();
    this.fetchParameterInfo();
    this.fetchZoomInfo();
    // this.fetchSupporterList();
    this.fetchProvider();
  },
  watch: {
    providerId: function(provider) {
      this.selectProvider(provider);
    }
  },

  methods: {
    ...mapActions("user", ["FetchUserInformation"]),
    editRoomSetting(userVCRInfo) {
      const formRequest = userVCRInfo.map((item, index) => {
        return {
          ...item,
          priority: index + 1
        };
      });
      return this.$axios.post(
        `${service_names.school}/zoom-setting`,
        formRequest
      );
    },

    //edit form
    editForm() {
      if (this.overMaximumOfWeight(this.parameterInfo)) {
        Message.error(this.$t("setting.total_weight_of_category"));
        return;
      }
      /*   if (!this.chatSetting.supporterSelectedList.length) {
       Message.error(this.$t("chat_room.empty_list"));
       return;
       }*/
      Promise.all([
        this.editParameterInfo(this.parameterInfo),
        this.editSchoolInfo(this.schoolInfo),
        this.editRoomSetting(this.userVCRInfo),
        // this.editSupporter(this.chatSetting.supporterSelectedList),
        this.editProvider(this.providerInfo)
      ]).finally(() => {
        // this.chatSetting.selectedSupporter = [];
        Message.success(this.$t("common.successfully"));
      });
    },

    //schoolinfo
    editSchoolInfo(schoolInfo) {
      return this.$axios.put(
        `${service_paths.schools}/${this.schoolId}`,
        schoolInfo
      );
    },

    //parameter
    overMaximumOfWeight(parameter) {
      const sumOfWeight = parameter.reduce((prev, curr) => {
        return +prev.weight + +curr.weight;
      });
      return sumOfWeight > 100;
    },
    editParameterInfo(parameterInfo) {
      return this.$axios.post(
        `${service_names.school}/updateOrInsert/activity-categories`,
        parameterInfo
      );
    },
    /*editSupporter(supporterList) {
     let supporterIds = supporterList.map(item => item._id);
     return this.$axios
     .post(`${service_names.school}/chat-platform/supporters`, {
     user_ids: supporterIds
     })
     .then(() => this.FetchUserInformation());
     },
     fetchSupporterList() {
     this.$axios
     .get(`${service_names.school}/chat-platform/supporters`, {
     limit: 1000
     })
     .then(res => {
     this.chatSetting.supporterSelectedList = res.data.data;
     });
     },*/
    // parameter
    deleteParameter(index) {
      this.parameterInfo.splice(index, 1);
    },
    addParameter() {
      this.parameterInfo = [...this.parameterInfo, ...parameterDefault()];
    },
    //vcr
    deleteVCRAccount(index) {
      this.userVCRInfo.splice(index, 1);
    },
    addVCRAccount() {
      this.userVCRInfo = [...this.userVCRInfo, ...userVCRDefault()];
    },

    //init
    fetchSchoolInfo() {
      this.$axios.get(`${service_paths.schools}/current`).then(response => {
        this.initSchoolInfo(response?.data?.school_no_sql);
      });
    },
    initSchoolInfo(data) {
      this.schoolInfo = pick(data, Object.keys(this.schoolInfo));
      this.schoolInfoDefault = pick(data, Object.keys(this.schoolInfo));
      this.schoolId = getId(data);
      this.timezoneDisplay = this.schoolInfo.timezone;
    },
    fetchParameterInfo() {
      this.$axios
        .get(`${service_names.school}/activity-categories/current-schools`)
        .then(response => {
          const data = [];
          response.data.forEach(item => {
            data.push({ name: item.name, weight: item.weight });
          });

          if (data.length > 0) {
            this.parameterInfo = data;
            this.parameterInfoDefault = data;
          }
        });
    },
    async fetchZoomInfo() {
      const response = await this.$axios.get(
        `${service_names.school}/zoom-setting`,
        { order_by: "priority ASC" }
      );
      this.userVCRInfo = response.data.map(item => {
        return {
          account: item.account,
          token: item.token
        };
      });
    },
    /*removeSelectedItem(id) {
     this.chatSetting.supporterSelectedList = this.chatSetting.supporterSelectedList.filter(
     item => item._id !== id
     );
     },
     fetchSupporter(searchKey) {
     this.chatSetting.supporterList = [];
     this.chatSetting.selectedSupporter = [];
     let param = {
     limit: 100,
     full_name_or_staff_code: searchKey || ""
     };
     this.$axios
     .get(
     `${service_paths.staffs}`,
     param,
     undefined,
     undefined,
     undefined,
     undefined,
     false
     )
     .then(res => {
     let dataList = res.data.data.filter(
     item =>
     !this.chatSetting.supporterSelectedList
     .map(data => data._id)
     .includes(item._id)
     );
     this.chatSetting.supporterList = dataList.map(item => {
     return {
     ...item,
     name: item.full_name + " - " + item.staff_code
     };
     });
     });
     },
     selectItem(event) {
     this.chatSetting.supporterSelectedList.push(event.itemData);
     },
     removedItem(event) {
     this.chatSetting.supporterSelectedList = this.chatSetting.supporterSelectedList.filter(
     item => item._id !== event.itemData?._id
     );
     },
     closeSelect() {
     this.chatSetting.selectedSupporter = [];
     },*/
    // sms settings settings
    selectProvider(provider) {
      const providerSelect = this.providerList.find(
        item => getId(item) === provider
      );
      this.providerInfo.external_id = providerSelect.external_id;
      this.providerInfo.token = providerSelect.token;
      this.providerInfo.phone_number = providerSelect.phone_number;
    },
    fetchProvider() {
      this.$axios.get(`${service_names.school}/sms-setting`).then(res => {
        this.providerList = res.data.data;
        this.providerId = this.providerList[0].id;
      });
    },
    editProvider(providerInfo) {
      return this.$axios.patch(
        `${service_names.school}/sms-setting/${this.providerId}`,
        providerInfo
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.form-actions {
  text-align: center;

  & > * ~ * {
    margin-left: 15px;
  }

  .md-button {
    box-shadow: 0px 2px 4px 0px #99999924;
    border-radius: 100px;
  }
}
</style>
